import { FC, useEffect, useMemo } from "react";

import ReactDOM from "react-dom";
import OverlayView from "Components/PopUpOverlay";
import { createUseStyles } from "react-jss";
import styles from "./styles";

const createOverlayElement = (classes: any) => {
  // Wrapper element
  const container = document.createElement("div"); // div.container
  container.className = classes.container; // Add the class
  return container;
};

interface Props {
  mapObj: any;
  position: any;
  children?: any;
}

const PopUpOverLay: FC<Props> = ({ mapObj, position, children }: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  const el = useMemo(() => {
    return createOverlayElement(classes);
  }, [classes]);

  useEffect(() => {
    const overLayObj = new OverlayView({
      position,
      content: el,
    });
    // eslint-disable-next-line no-unused-expressions
    overLayObj.setMap?.(mapObj.map);

    return () => {
      if (overLayObj) {
        // Removes the portal overlay
        overLayObj.setMap(null);
      }
    };
  }, [classes, el, mapObj.map, position]);

  return ReactDOM.createPortal(children, el);
};

export default PopUpOverLay;
